import type { ChatKitOptions } from "chatkit-web-shared/types"
import type { Auth, ConfigurableChatKitOptions } from "./types"

export const createChatKitOptions = ({
  auth,
  fetchHeaders,
  theme,
  initialThread,
  startScreen,
  threadItemActions,
  composer,
  widgets,
  features,
}: ConfigurableChatKitOptions & {
  auth: Auth
  fetchHeaders: Record<string, string>
  features?: Record<string, boolean>
}): ChatKitOptions => {
  return {
    // Fixed settings
    api: {
      ...auth,
      fetchHeaders,
      features,
    },
    threadItemActions: {
      feedback: true,
      share: threadItemActions?.share ?? true,
      retry: true,
    },
    header: {
      enabled: import.meta.env.MODE === "development",
    },
    // App-configurable settings below
    theme:
      typeof theme === "string"
        ? theme
        : theme
          ? {
              colorScheme: theme?.colorScheme,
              typography: theme?.typography,
            }
          : undefined,
    initialThread,
    startScreen,
    composer: {
      placeholder: composer?.placeholder,
      tools: composer?.tools,
      attachments: {
        enabled: true,
        maxSize: 20 * 1024 * 1024, // 20MB
        maxCount: 10,
      },
      visuallyDisableSubmitWhenEmpty: true,
    },
    widgets,
  }
}
